import React, { useContext, useCallback } from 'react';
import { FormInstance } from '@oscar/theme';
import Field, { CustomFieldProps } from './Field';
import { FormContext } from '../formContext';
import { set } from 'lodash';

const CustomField = <T extends CustomFieldProps>(
  props: T & {
    component: React.FunctionComponent<any>;
  }
) => {
  const { name, dependencies, component: Component, ...remain } = props;
  // const newProps = dependencies ? { dependencies } : { shouldUpdate: true };

  const formContext = useContext(FormContext);

  const getOtherField = useCallback(() => {
    if (dependencies && dependencies?.length > 0) {
      const result: {
        [index: string]: any;
      } = {};
      dependencies.forEach((key: string) => {
        set(result, key, formContext?.form?.getFieldValue(key?.split('.')));
        // result[key.toString()] = formContext?.form?.getFieldValue((key?.split(".")));
      });
      return result;
    }
    return undefined;
  }, [dependencies]);

  return (
    <Field {...remain} shouldUpdate={true} noStyle>
      {(fieldProps: FormInstance) => {
        const otherFields = getOtherField();
        const nextProps = {
          name,
          ...remain,
          otherFields,
          field: fieldProps,
        };
        return <Component {...nextProps} />;
      }}
    </Field>
  );
};

export default CustomField;
